module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("imwW1"))).then(() => parcelRequire('fThBo'));